<template>
  <el-select ref="cargoSelect" v-model="arrayVal" class="cargo-multi-select" multiple collapse-tags :disabled="disabled" :placeholder="disabled ? '': $t('CargoMsg.Cargo_PleaseSelect') " @change="onChange">
    <slot />
  </el-select>
</template>

<script>
export default {
  name: 'CargoMultiSelect',
  props: {
    value: { type: String, required: true, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      innerValue: '',
      arrayVal: []
    }
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        const curSelect = this.$refs.cargoSelect
        if (curSelect.multiple) {
          const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
          if (tagWrapper) {
            tagWrapper.innerHTML = null
          }
        }
      }
      if (newVal !== this.innerValue) {
        this.innerValue = newVal
        this.arrayVal = newVal ? newVal.split(',') : []
        this.convertSelectedToText()
      }
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
      this.arrayVal = this.value ? this.value.split(',') : []
      this.convertSelectedToText()
    }
  },
  methods: {
    onChange() {
      let text = ''
      if (this.arrayVal.length > 0) {
        text = this.arrayVal.reduce((a, b) => a + ',' + b)
      }
      this.innerValue = text
      this.$emit('input', text)
      this.$emit('change', text)
      this.convertSelectedToText()
    },
    convertSelectedToText() {
      this.$nextTick(() => {
        const curSelect = this.$refs.cargoSelect
        if (curSelect.multiple && curSelect.selected) {
          const selected = curSelect.selected.map(item => {
            return item.$el.innerText
          })
          const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
          tagWrapper.innerHTML = selected.length ? `<span>${selected.join(',')}</span>` : ''
        }
      })
    }
  }
}
</script>

<style lang="scss">
.cargo-multi-select{
  .el-select__tags {
    flex-wrap: nowrap;
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 8px;
      font-size: 12px;
      height: 14px;
      color: #606266;
      &>span{
        padding-left: 0;
        padding-right: 5px;
      }
    }
    input {
      min-width: 50px;
      font-size: 12px;
      margin-left: 0;
    }
  }
}
</style>
